module.exports = __webpack_public_path__ + "media/images/plans/wedding_reception/main-45976614e7637c6359774211dbb977b2.jpg";